export default __webpack_public_path__ + "img/coTChdrg.ef4b514f.svg";